import heic2any from 'heic2any';

/**
 * Converts HEIC/HEIF files to JPEG format for cross-platform compatibility
 * If the file is not HEIC/HEIF, returns the original file unchanged
 * @param {Object} fileData - File object containing name and binaryData
 * @returns {Promise<Object>} - Converted file data or original if not HEIC/HEIF
 */
export const convertHeicIfNeeded = async (fileData) => {
  const ext = fileData.name.split('.').pop().toLowerCase();

  // Check if file is HEIC or HEIF
  if (ext !== 'heic' && ext !== 'heif') {
    return fileData; // Return as-is if not HEIC/HEIF
  }

  try {
    console.log('Converting HEIC/HEIF file to JPEG:', fileData.name);

    // Convert ArrayBuffer to Blob
    const heicBlob = new Blob([fileData.binaryData], { type: 'image/heic' });

    // Convert HEIC to JPEG
    const jpegBlob = await heic2any({
      blob: heicBlob,
      toType: 'image/jpeg',
      quality: 0.9 // High quality JPEG
    });

    // Convert Blob back to ArrayBuffer
    const jpegArrayBuffer = await jpegBlob.arrayBuffer();

    // Update file name to .jpg
    const newFileName = fileData.name.replace(/\.(heic|heif)$/i, '.jpg');

    console.log('✅ Successfully converted to JPEG:', newFileName);

    return {
      ...fileData,
      name: newFileName,
      binaryData: jpegArrayBuffer
    };
  } catch (error) {
    console.error('❌ Error converting HEIC to JPEG:', error);
    throw new Error(
      `Failed to convert ${fileData.name} to JPEG. Please use JPG or PNG format instead.`
    );
  }
};

export const getFileNameFromSignedUrl = (signedUrls, type) => {
  let frontAttachment = null;
  let backAttachment = null;

  if (signedUrls?.length > 0) {
    // First pass: look for explicit front/back attachments
    signedUrls.forEach((item) => {
      if (item.key.includes('front_attachment')) {
        frontAttachment = item;
      } else if (item.key.includes('back_attachment')) {
        backAttachment = item;
      }
    });

    // Second pass: if no explicit attachments found, assign first file to front and second to back
    if (!frontAttachment && !backAttachment && signedUrls.length > 0) {
      frontAttachment = signedUrls[0];
      if (signedUrls.length > 1) {
        backAttachment = signedUrls[1];
      }
    }
  }

  if (type === 'front') {
    const fileName = frontAttachment?.key.split('/').pop();
    return {
      fileName
    };
  } else if (type === 'back') {
    const fileName = backAttachment?.key.split('/').pop();
    return {
      fileName
    };
  } else {
    return null;
  }
};
